import styled from 'styled-components';

export const StyledSection = styled.div`
  .authorBorder {
    border: 2px solid orange;
  }
`;
